export default "__VITE_ASSET__DS1$gsLC__"